import { colors } from '../../theme/tokens'

export function painColor(score: number | null | undefined): string {
  if (score == null) return colors.border
  const clamped = Math.max(0, Math.min(10, Math.round(score)))
  return colors.pain[clamped]
}

export function painTextColor(score: number): string {
  return score >= 3 && score <= 5 ? colors.textPrimary : '#fff'
}
